import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "rd-flex rd-gap-x-5 rd-w-full rd-flex-col md:rd-flex-row" }
const _hoisted_2 = { class: "rd-w-full rd-mb-2 md:rd-w-1/3 md:rd-mb-0" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "rd-grid rd-grid-cols-12 rd-gap-x-5 md:rd-flex md:rd-w-2/3" }
const _hoisted_5 = { class: "rd-relative rd-col-span-12 rd-mb-2 md:rd-mb-0 md:rd-w-1/2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "fa-solid fa-copy rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  key: 1,
  class: "fa-solid fa-check rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "rd-relative rd-col-span-6 md:rd-w-1/4" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fa-solid fa-copy rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_14 = {
  key: 1,
  class: "fa-solid fa-check rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "rd-relative rd-col-span-6 md:rd-w-1/4" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "fa-solid fa-copy rd-text-base rd-leading-none",
  "aria-hidden": "true"
}
const _hoisted_19 = {
  key: 1,
  class: "fa-solid fa-check rd-text-base rd-leading-none",
  "aria-hidden": "true"
}

import { Tooltip } from "floating-vue";
import { onBeforeMount, onMounted, ref, watch } from "vue";
import { MerchantType } from "@/enums";
import { useRenderStore } from "@/builder/stores/renderStore";
import {
    TestPaymentMethodsStripe,
    TestPaymentMethodsAuthNet,
} from "@/builder/enums";

export default /*@__PURE__*/_defineComponent({
  __name: 'TestPaymentsCard',
  setup(__props) {

const renderStore = useRenderStore();

// refs
const disabledTooltip = ref(false);

const testCard = ref("");
const isTestCardCopied = ref(false);
const testCardTooltip = ref("Copy to clipboard");

const testExpiration = ref("");
const isTestExpCopied = ref(false);
const testExpTooltip = ref("Copy to clipboard");

const testCvc = ref("123");
const isTestCvcCopied = ref(false);
const testCvcTooltip = ref("Copy to clipboard");

const testPaymentMethods =
    renderStore.page.merchantType === MerchantType.StripeUnified
        ? TestPaymentMethodsStripe
        : TestPaymentMethodsAuthNet;

// lifecycle hooks
onBeforeMount(() => {
    isSmallerScreen();
});

onMounted(async () => {
    if (renderStore.page.merchantType === MerchantType.StripeUnified) {
        testCard.value = TestPaymentMethodsStripe.Successful_Visa;
    } else {
        testCard.value = TestPaymentMethodsAuthNet.Successful_Visa;
    }
    setTestExpiration();
    setTestCvc();
});

// methods
const isSmallerScreen = () => {
    disabledTooltip.value = window.innerWidth < 768;
};

const cleanTestPayments = (payments) => {
    const testCardSplit = payments.split(/_(.*)/s);

    testCardSplit[0] += " -";

    if (testCardSplit[1].match(/.*[A-Z].*[A-Z].*/g)) {
        testCardSplit[1] = testCardSplit[1].split(/(?=[A-Z])/).join(" ");
    }

    return testCardSplit.join(" ");
};

const copyTestCard = () => {
    navigator.clipboard.writeText(testCard.value);
    isTestCardCopied.value = true;
    testCardTooltip.value = "Copied!";

    setTimeout(function () {
        isTestCardCopied.value = false;
        testCardTooltip.value = "Copy to clipboard";
    }, 2000);
};

const setTestExpiration = () => {
    const date = new Date();
    const year = date.getFullYear() + 2;
    testExpiration.value = "12/" + year.toString().substring(2);
};

const setTestCvc = () => {
    testCard.value.startsWith("3782")
        ? (testCvc.value = "1234")
        : (testCvc.value = "123");
};

const copyTestExpiration = () => {
    navigator.clipboard.writeText(testExpiration.value);
    isTestExpCopied.value = true;
    testExpTooltip.value = "Copied!";

    setTimeout(function () {
        isTestExpCopied.value = false;
        testExpTooltip.value = "Copy to clipboard";
    }, 2000);
};

const copyTestCvc = () => {
    navigator.clipboard.writeText(testCvc.value);
    isTestCvcCopied.value = true;
    testCvcTooltip.value = "Copied!";

    setTimeout(function () {
        isTestCvcCopied.value = false;
        testCvcTooltip.value = "Copy to clipboard";
    }, 2000);
};

// watchers
watch(testCard, (newVal) => {
    if (newVal) {
        setTestCvc();
    }
});

// Mobile resizing event
window.addEventListener("resize", isSmallerScreen);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("label", {
        for: "testCards",
        class: "rd-sr-only"
      }, " Test Payment Methods ", -1)),
      _withDirectives(_createElementVNode("select", {
        id: "testCards",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((testCard).value = $event)),
        class: "rd-pr-[30px]"
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("option", {
          disabled: "",
          value: ""
        }, "Please select", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(testPaymentMethods), (item, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: item,
            value: item
          }, _toDisplayString(cleanTestPayments(index)), 9, _hoisted_3))
        }), 128))
      ], 512), [
        [_vModelSelect, testCard.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("label", {
          for: "txtTestCard",
          class: "rd-sr-only"
        }, " Test Card Number ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "txtTestCard",
          readonly: "",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((testCard).value = $event)),
          disabled: !testCard.value
        }, null, 8, _hoisted_6), [
          [_vModelText, testCard.value]
        ]),
        _createVNode(_unref(Tooltip), {
          distance: "-4",
          container: ".test-payment-types",
          delay: "15",
          popperClass: "tooltip-sm",
          disabled: disabledTooltip.value,
          class: "rd-absolute rd-right-0 rd-top-0"
        }, {
          popper: _withCtx(() => [
            _createTextVNode(_toDisplayString(testCardTooltip.value), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "rd-py-[13px] rd-px-[15px] copy-card",
              onClick: copyTestCard,
              disabled: !testCard.value
            }, [
              (!isTestCardCopied.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                : (_openBlock(), _createElementBlock("i", _hoisted_9)),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "rd-sr-only" }, "Copy Test Card Number to clipboard", -1))
            ], 8, _hoisted_7)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[9] || (_cache[9] = _createElementVNode("label", {
          for: "txtTestExpiration",
          class: "rd-sr-only"
        }, "Test Expiration Date", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "txtTestExpiration",
          readonly: "",
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((testExpiration).value = $event)),
          disabled: !testCard.value
        }, null, 8, _hoisted_11), [
          [_vModelText, testExpiration.value]
        ]),
        _createVNode(_unref(Tooltip), {
          distance: "-4",
          container: ".test-payment-types",
          delay: "15",
          popperClass: "tooltip-sm",
          disabled: disabledTooltip.value,
          class: "rd-absolute rd-right-0 rd-top-0"
        }, {
          popper: _withCtx(() => [
            _createTextVNode(_toDisplayString(testExpTooltip.value), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "rd-py-[13px] rd-px-[15px] copy-card",
              onClick: copyTestExpiration,
              title: "Copy to clipboard",
              disabled: !testCard.value
            }, [
              (!isTestExpCopied.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                : (_openBlock(), _createElementBlock("i", _hoisted_14)),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "rd-sr-only" }, "Copy Test Expiration Date to clipboard", -1))
            ], 8, _hoisted_12)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          for: "txtTestCvc",
          class: "rd-sr-only"
        }, "Test Security Code", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "txtTestCvc",
          readonly: "",
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((testCvc).value = $event)),
          disabled: !testCard.value
        }, null, 8, _hoisted_16), [
          [_vModelText, testCvc.value]
        ]),
        _createVNode(_unref(Tooltip), {
          distance: "-4",
          container: ".test-payment-types",
          delay: "15",
          popperClass: "tooltip-sm",
          disabled: disabledTooltip.value,
          class: "rd-absolute rd-right-0 rd-top-0"
        }, {
          popper: _withCtx(() => [
            _createTextVNode(_toDisplayString(testCvcTooltip.value), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "rd-py-[13px] rd-px-[15px] copy-card",
              onClick: copyTestCvc,
              title: "Copy to clipboard",
              disabled: !testCard.value
            }, [
              (!isTestCvcCopied.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                : (_openBlock(), _createElementBlock("i", _hoisted_19)),
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "rd-sr-only" }, "Copy Test Security Code to clipboard", -1))
            ], 8, _hoisted_17)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})